import { ReactNode } from "react";
import { MaskLines, Reveal } from "@/components/site/Motion";
import { LeafCutout } from "./Decor";

export function PageIntro({ eyebrow, lines, intro, script, aside, testId, tone = "dark" }: { eyebrow: string; lines: ReactNode[]; intro: string; script?: string; aside?: ReactNode; testId: string; tone?: "dark" | "beige" }) {
  const dark = tone === "dark";
  return (
    <section data-testid={testId} className={`grain relative overflow-hidden pb-20 pt-14 sm:pb-28 sm:pt-20 ${dark ? "bg-forest-deep text-cream" : "bg-beige text-charcoal"}`}>
      <LeafCutout variant="a" className="-right-16 -top-6 z-0 h-40 w-32 opacity-50 sm:-top-10 sm:h-96 sm:w-80 sm:opacity-90" />
      <div className="wrap relative z-10 grid items-center gap-12 lg:grid-cols-12">
        <div className={aside ? "lg:col-span-7" : "lg:col-span-9"}>
          <Reveal y={16}><p className={dark ? "eyebrow-dark" : "eyebrow"}><span className="h-px w-8 bg-gold" />{eyebrow}</p></Reveal>
          <h1 className={`mt-6 text-[3rem] leading-[0.95] sm:text-7xl lg:text-[5.6rem] ${dark ? "text-cream" : "text-forest"}`}>
            <MaskLines lines={lines} onLoad delay={0.1} />
          </h1>
          <Reveal delay={0.35}><p className={`mt-7 max-w-xl text-base leading-relaxed sm:text-lg ${dark ? "text-cream/85" : "text-charcoal-soft"}`}>{intro}</p></Reveal>
          {script && <Reveal delay={0.5}><p className={`mt-6 font-script text-3xl sm:text-4xl ${dark ? "text-gold-soft" : "text-gold-ink"}`}>{script}</p></Reveal>}
        </div>
        {aside && <Reveal delay={0.25} className="lg:col-span-5">{aside}</Reveal>}
      </div>
    </section>
  );
}
